import SvgIcon from '@material-ui/core/SvgIcon';

const IQEAgentMenuIcon = () => {
  return (
    <SvgIcon
      width="19"
      height="26"
      viewBox="0 0 19 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="5" y="20.5" width="8" height="1" fill="currentColor" />
      <rect x="5" y="22.5" width="8" height="1" fill="currentColor" />
      <rect x="7" y="24.5" width="4" height="1" fill="currentColor" />
      <path
        d="M9.10547 0C14.1504 0.000176131 18.2549 4.10509 18.2549 9.14453C18.2548 11.8494 17.0436 14.405 14.9307 16.1641L14.9248 16.1699C14.1559 16.9942 13.8851 18.0895 13.791 18.875C13.7578 19.1515 13.5196 19.3671 13.2432 19.3672H4.9834C4.70165 19.367 4.46992 19.1571 4.43652 18.8809C4.41994 18.7482 4.40855 18.6095 4.39746 18.4658C4.32553 17.6582 4.25387 16.8168 3.44629 16.1475C2.40634 15.1573 0.000138752 12.5189 0 9.14453C0 4.10498 4.08801 0 9.10547 0ZM12.0586 3.71582C12.3088 3.07376 11.6102 2.73103 11.1621 3.26074L5.17773 10.3369C5.06571 10.4741 5.00003 10.5992 5 10.7363C5 10.9795 5.19781 11.1602 5.47461 11.1602H9.19824L7.23438 16.2109C6.97735 16.8532 7.68173 17.1956 8.12988 16.6719L14.1143 9.58887C14.226 9.45815 14.2851 9.33355 14.2852 9.19043C14.2852 8.95357 14.094 8.76579 13.8174 8.76562H10.0879L12.0586 3.71582Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default IQEAgentMenuIcon;
